module.exports = __webpack_public_path__ + "img/texts.d78d74de.svg";